const state = {
  loading: false,
  userInfo:{},
}

const getters = {
  s_loading(state) {
    return state.loading
  },
  s_userInfo(state) {
    return state.userInfo
  }
}

const mutations = {
  SET_LOADING: (state, flag) => {
    state.loading = flag
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
}

const actions = {
  setLoading({commit}, flag) {
    commit('SET_LOADING', flag)
  },
  setUserInfo({commit}, userInfo) {
    commit('SET_USERINFO', userInfo)
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
